module.exports = __webpack_public_path__ + "static/media/wine.f6f714a0.jpg";